import React from 'react'
import axios from 'axios';
import FooterBanner from './FooterBanner';
import Header from './Header';
import Footer from './Footer';
class ContactForm extends React.Component {
constructor(props) {
super(props);
this.state = {
name: '',
email: '',
mobile: '',
message: ''
}
}
handleSubmit(e){
e.preventDefault();
axios({
method: "POST", 
url:"https://tallysolutions-uae.com/tallyprime/api/forms/contactform.php", 
data:  this.state
}).then((response)=>{
if (response.data.status === 'success'){
this.setState({ successSend: "Thank you for contacting us – we will get back to you soon!" });
setTimeout( () => {
this.setState({ successSend: "" });
}, 5000);
this.resetForm()
}else if(response.data.status === 'fail'){
this.setState({ failedSend: "Sorry, something went wrong there. Try again." });
setTimeout( () => {
this.setState({ failedSend: "" });
}, 5000);
}
})
}
resetForm(){
this.setState({name: '', email: '', mobile: '', message: ''})
}
render() {
    return (
  
        <React.StrictMode>
   <Header/>

   <section  className="pt-5 pb-sm-5 pb-0 border-top">
        <div className="container mt-lg-5 ">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center">
              <h2 className="section-title mb-sm-4 mt-0" style={{textTransform: 'initial'}}> Get 7-days free trial
</h2>
              <p className="text-muted mb-0 mb-sm-3">A valid TSS subscription ensures that you can move to TallyPrime for free. If you don’t have one, all you need to do is visit <a className="text-muted" target="_blank" href="http://www.tallysolutions-uae.com" rel="noopener noreferrer">www.tallysolutions-uae.com</a> Alternatively, you can also get in touch with your Tally Partner.

</p>
<div className="row">
            <div className="col-lg-12 mx-auto text-center">
            <div className="card p-md-5 rounded-0 border-0 shadow-0  mb-3 mb-md-5">
<form  onSubmit={this.handleSubmit.bind(this)} method="POST">
                       <div className="row">
                          <div className="col-lg-12 mb-4">
                             <div className="alert success-alert"> {this.state.successSend} </div>
                      
                             <div className="alert danger-alert"> {this.state.failedSend} </div>
                       
                          </div>
                          <div className="col-lg-12">
                             <div className="form-group">
                                <input type="text" className="form-control rounded-0 pl-3 pt-4 pb-4 pr-3" placeholder="Name" value={this.state.name} onChange={this.onNameChange.bind(this)} required/>
                             </div>
                          </div>
                          <div className="col-lg-6 pr-lg-0">
                             <div className="form-group">
                                <input type="email" className="form-control rounded-0 pl-3 pt-4 pb-4 pr-3" placeholder="Email" value={this.state.email} onChange={this.onEmailChange.bind(this)} required/>
                             </div>
                          </div>
                          <div className="col-lg-6">
                             <div className="form-group">
                                <input type="number" className="form-control rounded-0 pl-3 pt-4 pb-4 pr-3" placeholder="Mobile" value={this.state.mobile} onChange={this.onMobileChange.bind(this)} required/>
                             </div>
                          </div>
                          <div className="col-lg-12 ">
                             <div className="form-group">
                                <textarea rows="6" className="form-control rounded-0 pl-3 pt-3 pb-4 pr-3" placeholder="Message" value={this.state.message} onChange={this.onMessageChange.bind(this)} required/>
                             </div>
                          </div>
                          <div className="col-lg-12">
                             <div className="form-group">
                                <button type="submit" style={{    lineHeight: '48px', fontSize:  '15px', fontWeight: '400'}}  className="btn-cu bg-secondary2 text-uppercase w-100 border-0 m-0">Send Now</button>
                             </div>
                          </div>
                       </div>
                    </form>
                    </div>
            </div>
            </div>

            </div>
          </div>
        </div>
      </section>
      <FooterBanner/>
    <Footer/>
</React.StrictMode>


    )
  }
onNameChange(event) {
this.setState({name: event.target.value})
}
onEmailChange(event) {
this.setState({email: event.target.value})
}
onMobileChange(event) {
this.setState({mobile: event.target.value})
}
onMessageChange(event) {
this.setState({message: event.target.value})
}
}
export default ContactForm